<template>
  <div class="SupporterWidget">
    <div class="wrapper">
      <div class="imgWrapper">
        <img class="supporterLogo" :src="image" :alt="title" />
      </div>
      <div class="contentWrapper">
        <div class="title" v-html="title"></div>
        <div class="content" v-html="content"></div>
      </div>
      <div class="linkWrapper">
        <a :href="ctaHref" target="_blank">
          {{ ctaText }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SupporterWidget',
    props: {
      id: {
        type: String,
        default: 0
      },
      image: {
        type: String,
        default: ""
      },
      title: {
        type: String,
        default: ""
      },
      ctaHref: {
        type: String,
        default: ""
      },
      ctaText: {
        type: String,
        default: ""
      },
      content: {
        type: String,
        default: ""
      }
    },
    mounted(){
      console.log(this.image)
    }
  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  .SupporterWidget{
    .wrapper{
      @media (min-width: @bootstrap-md){
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
      }
    }

    .imgWrapper{
      margin-bottom: 15px;
      img{
        width: 184px;
        height: 120px;
      }

      @media (min-width: @bootstrap-md){
        margin-bottom: 0;
        margin-right: 40px;
      }
    }

    .contentWrapper{
      margin-bottom: 15px;
      font-size: 18px;
      line-height: 26px;
      @media (min-width: @bootstrap-md){
        margin-bottom: 0;
        flex-basis: 50%;
      }

      @media (min-width: @bootstrap-lg){
        flex-basis: 58%;
      }
    }

    .title{
      font-weight: bold;
    }

    .linkWrapper{
      a:link, a:visited, a:hover, a:active{
        font-size: 15px;
        text-transform: uppercase;
        font-weight: bold;
        letter-spacing: 2px;
        text-decoration: none;
      }
    }
  }
</style>
